import React, { useState, useContext } from 'react';
import { ClientLoginRequest, ClientLoginResponse } from '../types/login';
import { toast } from 'react-toastify';
import { AuthContext } from '../AuthContext';
import { useNavigate } from "react-router-dom";
import apiClient, { setApiClientRefreshToken, setApiClientToken } from '../main/apiClient';
import { useTranslation } from 'react-i18next';

const LoginForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setToken, setRefreshToken, setRoles, setUsersName, setOrganisationId, setUserId, setOrganisationName } = useContext(AuthContext);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoginProgress, setIsLoginProgress] = useState(false);
  const loginRequest: ClientLoginRequest = { username: username, password: password, applicationInstanceID: '00000000-0000-0000-0000-000000000000' };
  const [showPassword, setShowPassword] = useState(false);

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setIsLoginProgress(true);

    try {
      const resp = await apiClient.post('authentication/login', loginRequest);
      const loginResponse: ClientLoginResponse = resp.data;      
      setToken(loginResponse.accessToken);
      setRefreshToken(loginResponse.refreshToken);
      setRoles(loginResponse.roles);
      setUsersName(loginResponse.name);
      setOrganisationId(loginResponse.organisationId);
      setOrganisationName(loginResponse.organisationName);
      setUserId(loginResponse.userId);
      setApiClientToken(loginResponse.accessToken);
      setApiClientRefreshToken(loginResponse.refreshToken);
      navigate('/home');
    } catch (error) {
      setPassword('');
      console.error('Error:', error);
      toast.error(t('login.error'));
    } finally {
      setIsLoginProgress(false);
    }
  };

  return (
    <form className="login-form">
      <div className="form-group">
        <div className="login-input-group">
          <label htmlFor="username">{t('common.username')}</label>
          <input 
            id="username"
            type="text" 
            className="form-control login-input" 
            value={username} 
            onChange={(e) => setUsername(e.target.value)} 
          />
        </div>
        <div className="login-input-group">
          <label htmlFor="password">{t('common.password')}</label>
          <div className="input-group">
            <input
              id="password"
              className="form-control login-input-with-button"
              type={showPassword ? "text" : "password"}
              maxLength={64}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? t('common.hide') : t('common.show')}
            </button>
          </div>
        </div>
        <button
          className="btn btn-primary mt-3 me-2"
          disabled={!username || !password || isLoginProgress}
          onClick={onSubmit}>
          {t('login.login')}
        </button>
      </div>
    </form>
  );
};

export default LoginForm;